// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".friendship-level-root .van-swipe__indicators .van-swipe__indicator {\n  width: 0.8rem;\n  height: 0.10667rem;\n  background: #e6e5e7 !important;\n  border-radius: 0.05333rem;\n}\n.friendship-level-root .van-swipe__indicators .van-swipe__indicator--active {\n  background: #b2b2b2 !important;\n}", ""]);
// Exports
module.exports = exports;
